import { createRouter, createWebHistory } from "vue-router";
import * as cmUtil from "@/utils/cmUtil.js";

import paintpro_login from "../pages/paintpro/login/index.vue";
import paintpro_member from "../pages/paintpro/member/index.vue";
import paintpro_main from "../pages/paintpro/main/index.vue";
import paintpro_prodList from "../pages/paintpro/prodList/index.vue"; // 1.제품주문 > 1.건축/공업/자보
import paintpro_myRoom from "../pages/paintpro/myRoom/index.vue"; // 1.제품주문 > 2.마이룸 제품조회
import paintpro_orderList from "../pages/paintpro/orderList/index.vue"; // 2.주문현황황 > 1.주문현황
import paintpro_orderList_purchaseList from "../pages/paintpro/orderList/purchaseList.vue"; // 2.주문현황황 > 3.매입현황황
import paintpro_orderList_shipmentList from "../pages/paintpro/orderList/shipmentList.vue"; // 2.주문현황황 > 2.출고현황
import paintpro_orderDetail from "../pages/paintpro/orderList/detail/index.vue";
import paintpro_moListDetail from "../pages/paintpro/orderList/moListDetail/index.vue";
import paintpro_utility from "../pages/paintpro/utility/index.vue";
import paintpro_utility_memberInfo from "../pages/paintpro/utility/MemberInfo.vue";
import paintpro_utility_delivMng from "../pages/paintpro/utility/DelivMng.vue";
import paintpro_utility_mileage from "../pages/paintpro/utility/MileageMng.vue";
import paintpro_utility_colorMng from "../pages/paintpro/utility/ColorMng.vue";
import paintpro_utility_inquireList from "../pages/paintpro/utility/InquireList.vue";
import paintpro_orderBasket from "../pages/paintpro/order/basket.vue";
import paintpro_orderOrder from "../pages/paintpro/order/order.vue";
import paintpro_rcentlyViewedProd from "../pages/paintpro/quickMenu/rcentlyViewedProd.vue";
import paintpro_search from "../pages/paintpro/search/index.vue";
import paintpro_colorCombinList from "../pages/paintpro/colorCombinList/index.vue"; // 3.조색배합 > 1.조색배합문의
import paintpro_colorCombinList_updateList from "../pages/paintpro/colorCombinList/updateList.vue"; // 3.조색배합 > 2.업데이트
import paintpro_colorCombinList_colorSearch from "../pages/paintpro/colorCombinList/colorSearch.vue"; // 3.조색배합 > 3.색상찾기
import paintpro_colorCombinList_munsellColorSearch from "../pages/paintpro/colorCombinList/munsellColorSearch.vue"; // 3.조색배합 > 4.컬러코드찾기(먼셀코드)
import paintpro_aiColorMatching from "../pages/paintpro/colorCombinList/aiColorMatching.vue"; // 3.조색배합 > 5.NOROO SMART MIX
import paintpro_colorCombinmixedInq from "../pages/paintpro/colorCombinmixedInq/index.vue";
import paintpro_custCenterList from "../pages/paintpro/custCenterList/index.vue"; // 4.고객센터터 > 1.자주찾는질문
import paintpro_custCenterList_reqList from "../pages/paintpro/custCenterList/reqList.vue"; // 4.고객센터터 > 2.1:1문의
import paintpro_custCenterList_noticeList from "../pages/paintpro/custCenterList/noticeList.vue"; // 4.고객센터터 > 3.공지사항
import paintpro_etc_prodDtl from "../pages/paintpro/powerUp/productDtl.vue"; // 파워업 제품 상세
import paintpro_etc_login from  "../pages/paintpro/powerUp/powerupLogin.vue"; // 파워업 제품 상세
import paintpro_error404 from "../pages/paintpro/error/error404.vue";
import paintpro_error500 from "../pages/paintpro/error/error500.vue";
import paintpro_systemCheck from "../pages/paintpro/error/systemCheck.vue";

// import Main from "../pages/main/index.vue";
import Member from "../pages/member/index.vue";
import Idsrch from "../pages/member/idSrch.vue";
import Pwdsrch from "../pages/member/pwdSrch.vue";
// import Charts from "../pages/chart/chartsample.vue";
import Charts2 from "../pages/chart/chartsample2.vue";
// import MBasket from "../pages/quick/mbasket/index.vue";
// import Order from "../pages/order/index.vue";
// import Login from "../pages/index.vue";
import Logout from "../pages/login/logout.vue";

const routes_base = [
  {
    path: "/",
    name: "/",
    component: paintpro_login,
    meta: { title: "아이디 로그인" },
  },
  {
    path: "/paintpro/login",
    name: "/paintpro/login",
    component: paintpro_login,
    meta: { title: "아이디 로그인" },
  },
  {
    path: "/paintpro/member",
    name: "/paintpro/member",
    component: paintpro_member,
    meta: { title: "회원가입" },
  },
  {
    path: "/paintpro/main",
    name: "/paintpro/main",
    component: paintpro_main,
    meta: { title: "홈", requiresAuth: true },
  },
  {
    // 1.제품주문 > 1.건축/공업/자보
    path: "/paintpro/prodList",
    name: "/paintpro/prodList",
    component: paintpro_prodList,
    meta: { title: "제품주문", requiresAuth: true },
  },
  {
    // 1.제품주문 > 2.마이룸
    path: "/paintpro/myRoom",
    name: "/paintpro/myRoom",
    component: paintpro_myRoom,
    meta: { title: "제품조회", requiresAuth: true },
  },
  {
    // 2.주문현황황 > 1.주문현황
    path: "/paintpro/orderList",
    name: "/paintpro/orderList",
    component: paintpro_orderList,
    meta: { title: "주문현황", requiresAuth: true },
  },
  {
    path: "/paintpro/orderList/detail/:id",
    name: "/paintpro/orderDetail",
    component: paintpro_orderDetail,
    meta: { title: "주문상세", requiresAuth: true },
  },
  {
    path: "/paintpro/orderList/moListDetail",
    name: "/paintpro/orderList/moListDetail",
    component: paintpro_moListDetail,
    meta: { title: "주문상세", requiresAuth: true },
  },
  {
    // 2.주문현황황 > 2.출고현황
    path: "/paintpro/orderList/shipmentList",
    name: "/paintpro/orderList/shipmentList",
    component: paintpro_orderList_shipmentList,
    meta: { title: "출고현황", requiresAuth: true },
  },
  {
    // 2.주문현황황 > 3.매입현황
    path: "/paintpro/orderList/purchaseList",
    name: "/paintpro/orderList/purchaseList",
    component: paintpro_orderList_purchaseList,
    meta: { title: "매입현황", requiresAuth: true },
  },
  {
    path: "/paintpro/orderBasket",
    name: "/paintpro/orderBasket",
    component: paintpro_orderBasket,
    meta: { title: "장바구니", requiresAuth: true },
  },
  {
    path: "/paintpro/orderOrder",
    name: "/paintpro/orderOrder",
    component: paintpro_orderOrder,
    meta: { title: "주문서작성", requiresAuth: true },
  },
  {
    path: "/paintpro/quickMenu/rcentlyViewedProd",
    name: "/paintpro/quickMenu/rcentlyViewedProd",
    component: paintpro_rcentlyViewedProd,
    meta: { title: "최근본상품", requiresAuth: true },
  },
  {
    // 3.조색배합 > 1.조색배합문의
    path: "/paintpro/colorCombinList",
    name: "/paintpro/colorCombinList",
    component: paintpro_colorCombinList,
    meta: { title: "조색배합문의", requiresAuth: true },
  },
  {
    // 3.조색배합 > 1.조색배합문의 > 상세
    path: "/paintpro/colorCombinList/:id",
    name: "/paintpro/colorCombinList/detail",
    component: paintpro_colorCombinList,
    meta: { title: "조색배합문의", requiresAuth: true }, // 상세
  },
  {
    path: "/paintpro/colorCombinmixedInq",
    name: "/paintpro/colorCombinmixedInq",
    component: paintpro_colorCombinmixedInq,
    meta: { title: "조색배합문의", requiresAuth: true },
  },
  {
    // 3.조색배합 > 2) 업데이트
    path: "/paintpro/colorCombinList/updateList",
    name: "/paintpro/colorCombinList/updateList",
    component: paintpro_colorCombinList_updateList,
    meta: { title: "업데이트", requiresAuth: true },
  },
  {
    // 3.조색배합 > 2) 업데이트 > 상세
    path: "/paintpro/colorCombinList/updateList/:id",
    name: "/paintpro/colorCombinList/updateList/detail",
    component: paintpro_colorCombinList_updateList,
    meta: { title: "업데이트", requiresAuth: true }, // 상세
  },
  {
    // 3.조색배합 > 3) 색상찾기
    path: "/paintpro/colorCombinList/colorSearch",
    name: "/paintpro/colorCombinList/colorSearch",
    component: paintpro_colorCombinList_colorSearch,
    meta: { title: "색상찾기", requiresAuth: true },
  },
  {
    // 3.조색배합 > 4) 컬러코드찾기
    path: "/paintpro/colorCombinList/munsellColorSearch",
    name: "/paintpro/colorCombinList/munsellColorSearch",
    component: paintpro_colorCombinList_munsellColorSearch,
    meta: { title: "컬러코드찾기", requiresAuth: true },
  },
  {
    // 3.조색배합 > NOROO SMART MIX
    path: "/paintpro/colorCombinList/aiColormatching",
    name: "/paintpro/colorCombinList/aiColormatching",
    component: paintpro_aiColorMatching,
    meta: { title: "NOROO SMART MIX", requiresAuth: true },
  },
  {
    // 4.고객센터 > 1) 자주찾는질문
    path: "/paintpro/custCenterList",
    name: "/paintpro/custCenterList",
    component: paintpro_custCenterList,
    meta: { title: "자주찾는질문", requiresAuth: true },
  },
  {
    // 4.고객센터 > 2) 1:1문의
    path: "/paintpro/custCenterList/reqList",
    name: "/paintpro/custCenterList/reqList",
    component: paintpro_custCenterList_reqList,
    meta: { title: "1:1문의", requiresAuth: true },
  },
  {
    // 4.고객센터 > 3) 공지사항
    path: "/paintpro/custCenterList/noticeList",
    name: "/paintpro/custCenterList/noticeList",
    component: paintpro_custCenterList_noticeList,
    meta: { title: "공지사항", requiresAuth: true },
  },
  {
    // 4.고객센터 > 3) 공지사항 > 상세
    path: "/paintpro/custCenterList/noticeList/:id",
    name: "/paintpro/custCenterList/noticeList/detail",
    component: paintpro_custCenterList_noticeList,
    meta: { title: "공지사항", requiresAuth: true }, // 상세
  },
  {
    // 검색
    path: "/paintpro/search",
    name: "/paintpro/search",
    component: paintpro_search,
    meta: { title: "검색", requiresAuth: true },
  },
  {
    // 내정보 > 1) 회원정보관리
    path: "/paintpro/utility",
    name: "/paintpro/utility",
    component: paintpro_utility,
    meta: { title: "회원정보관리", requiresAuth: true },
  },
  {
    // 내정보 > 1) 회원정보관리
    path: "/paintpro/utility/memberInfo",
    name: "/paintpro/utility/memberInfo",
    component: paintpro_utility_memberInfo,
    meta: { title: "회원정보관리", requiresAuth: true },
  },
  {
    // 내정보 > 2) 배송지관리
    path: "/paintpro/utility/delivMng",
    name: "/paintpro/utility/delivMng",
    component: paintpro_utility_delivMng,
    meta: { title: "배송지관리", requiresAuth: true },
  },
  {
    // 내정보 > 3) 조색기관리
    path: "/paintpro/utility/colorMng",
    name: "/paintpro/utility/colorMng",
    component: paintpro_utility_colorMng,
    meta: { title: "조색기관리", requiresAuth: true },
  },
  {
    // 내정보 > 문의내역
    path: "/paintpro/utility/inquireList",
    name: "/paintpro/utility/inquireList",
    component: paintpro_utility_inquireList,
    meta: { title: "문의내역", requiresAuth: true },
  },
  {
    // 내정보 > 문의내역 > 상세
    path: "/paintpro/utility/inquireList/:id",
    name: "/paintpro/utility/inquireList/detail",
    component: paintpro_utility_inquireList,
    meta: { title: "문의내역", requiresAuth: true }, // 상세
  },
  {
    // 내정보 > 마일리지내역
    path: "/paintpro/utility/MileageMng",
    name: "/paintpro/utility/MileageMng",
    component: paintpro_utility_mileage,
    meta: { title: "마일리지내역", requiresAuth: true },
  },
  {
    // 파워업 상세 화면
    path: "/paintpro/etc/prodDtl",
    name: "/paintpro/etc/prodDtl",
    component: paintpro_etc_prodDtl,
    meta: { title: "", requiresAuth: false },
  },
  {
    // 파워업 로그인
    path: "/paintpro/etc/login",
    name: "/paintpro/etc/login",
    component: paintpro_etc_login,
    meta: { title: "", requiresAuth: false },
  },
  {
    // error404
    path: "/paintpro/error/error404",
    name: "/paintpro/error/error404",
    component: paintpro_error404,
    meta: { title: "오류404" },
  },
  {
    // error500
    path: "/paintpro/error/error500",
    name: "/paintpro/error/error500",
    component: paintpro_error500,
    meta: { title: "오류500" },
  },
  {
    // systemCheck
    path: "/paintpro/error/systemCheck",
    name: "/paintpro/error/systemCheck",
    component: paintpro_systemCheck,
    meta: { title: "시스템공지" },
  },
];

const routes_base_old = [
  // {
  //   path: "/",
  //   name: "Login",
  //   component: Login,
  //   meta: { title: "아이디 로그인" },
  // },
  // {
  //   path: "/login",
  //   name: "Login",
  //   component: Login,
  //   meta: { title: "아이디 로그인" },
  // },
  // {
  //   path: "/Main",
  //   name: "Main",
  //   component: Main,
  //   meta: { title: "홈" },
  // },
  {
    path: "/member",
    name: "Member",
    component: Member,
    meta: { title: "회원가입" },
  },
  // {
  //   path: "/MBasket",
  //   name: "MBasket",
  //   component: MBasket,
  //   meta: { title: "장바구니" },
  // },
  // {
  //   path: "/Order",
  //   name: "Order",
  //   component: Order,
  //   meta: { title: "주문" },
  // },
  {
    path: "/member/idSrch",
    name: "Idsrch",
    component: Idsrch,
    meta: { title: "아이디찾기" },
  },
  {
    path: "/member/pwdsrch",
    name: "Pwdsrch",
    component: Pwdsrch,
    meta: { title: "비밀번호찾기" },
  },
  // {
  //   path: "/chart",
  //   name: "Charts",
  //   component: Charts,
  //   meta: { title: "차트" },
  // },
  {
    path: "/chart2",
    name: "Charts2",
    component: Charts2,
    meta: { title: "차트2" },
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
    meta: { title: "로그아웃" },
  },
];

const routes_last = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/paintpro/error/error404",
  },
];

const routes = [...routes_base, ...routes_base_old, ...routes_last];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

// 이전 페이지 추적을 위한 변수
let previousRoute = null;

router.beforeEach((to, from, next) => {
  document.title = (to.meta?.title || "") + " | 노루 페인트 프로";

  if (
    ["", "/", "/paintpro/login"].includes(from.path) &&
    ["/paintpro/main"].includes(previousRoute?.path) &&
    ["/paintpro/main"].includes(to.path)
  ) {
    next(false);
  } else if (
    ["", "/", "/paintpro/login"].includes(from.path) &&
    ["/logout"].includes(previousRoute?.path) &&
    ["/logout"].includes(to.path)
  ) {
    next(false);
  } else if (
    ["/paintpro/main"].includes(from.path) &&
    ["", "/", "/paintpro/login"].includes(previousRoute?.path) &&
    ["", "/", "/paintpro/login"].includes(to.path)
  ) {
    next(false);
  } else if (to.matched.some((record) => record.meta?.requiresAuth)) {
    const isAuthenticated = !!localStorage.getItem("token");
    if (!isAuthenticated) {
      cmUtil.removeLocalStorage("gv.returnUrl");
      if (to.path && to.path.length > 3) {
        if (
          !(
            to.path.indexOf("login") > -1 ||
            to.path.indexOf("main") > -1 ||
            to.path.indexOf("member") > -1
          )
        ) {
          cmUtil.setLocalStorage("gv.returnUrl", to.path);
        }
      }
      next("/paintpro/login");
    } else {
      previousRoute = from;
      next();
    }
  } else {
    previousRoute = from;
    next();
  }
});

router.afterEach((to) => {
  if (["production"].includes(process.env.NODE_ENV)) {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: to.fullPath,
        page_title: to.name || document.title,
        node_env: process.env.NODE_ENV,
      });
    }
  }
});

export default router;
